import { LoadablePaint } from '@confluence/loadable';

export const BlogPostsMacroHandler = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-BlogPostsMacro" */ '../src/BlogPostsMacroRenderer.tsx'
			)
		).BlogPostsMacroRenderer,
});
